import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '@/redux';
import type { OrderItem } from '../types';

interface UseStaleGoldItemsResult {
  staleItemIds: Set<string>;
  count: number;
}

export function useStaleGoldItems(orderItems: OrderItem[]): UseStaleGoldItemsResult {
  const prices = useSelector((s: RootState) => s.goldPrice.prices);

  return useMemo(() => {
    const byCode = new Map(prices.map((p) => [p.type, p]));
    const ids = new Set<string>();

    for (const item of orderItems) {
      if (item.pricingMethod === 'FIXED') continue;
      if (!item.instrumentCode) continue;
      const q = byCode.get(item.instrumentCode);
      if (!q) continue;

      const bidChanged = q.buy !== item.appliedBid;
      const askChanged = q.sell !== item.appliedAsk;
      const overrideChanged = (q.overrideApplied ?? false) !== (item.appliedOverride ?? false);

      if (bidChanged || askChanged || overrideChanged) {
        ids.add(item.id);
      }
    }

    return { staleItemIds: ids, count: ids.size };
  }, [orderItems, prices]);
}
